export const Card = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="7" width="26" height="18" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M6 21H16" stroke="currentColor" stroke-width="2"/>
<path d="M4 12L28 12" stroke="currentColor" stroke-width="2"/>
<path d="M4 14L28 14" stroke="currentColor" stroke-width="2"/>
</svg>`;
